import React, { useState } from "react";
import api from "@/lib/api";
import { Gift, Send, Loader2, X } from "lucide-react";
import { toast } from "sonner";

export function GiftCreditsDialog({ open, onClose, onSent, balance }) {
  const [recipient, setRecipient] = useState("");
  const [amount, setAmount] = useState(50);
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);

  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!recipient || amount <= 0) return;
    setSaving(true);
    try {
      const r = await api.post("/credits/gift", { recipient: recipient.trim(), amount: Number(amount), message });
      toast.success(`+${amount} kredit elküldve ${r.data.recipient?.name || r.data.recipient?.email}-nek`);
      setRecipient(""); setAmount(50); setMessage("");
      onSent?.(r.data.credits);
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Ajándékozás sikertelen");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="gift-dialog" className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4">
      <form onSubmit={submit} className="w-full max-w-md bg-anthracite-800 border border-white/10 rounded-3xl p-6 relative">
        <button type="button" onClick={onClose} data-testid="gift-dialog-close" className="absolute top-3 right-3 p-2 rounded-full hover:bg-white/10">
          <X className="w-4 h-4" />
        </button>
        <div className="flex items-center gap-2 mb-4">
          <Gift className="w-5 h-5 text-emerald-400" strokeWidth={1.5} />
          <h3 className="font-heading text-xl">Kredit ajándékozása</h3>
        </div>
        <p className="text-xs text-slate-400 mb-4">Küldj kreditet egy másik AutoPark eladónak. Egyenleged: <b>{balance} kredit</b>.</p>
        <div className="space-y-3">
          <div>
            <label className="text-xs uppercase tracking-wide text-slate-400 block mb-1">Címzett (email vagy meghívó kód)</label>
            <input
              data-testid="gift-recipient"
              required
              value={recipient}
              onChange={(e) => setRecipient(e.target.value)}
              placeholder="elado@pelda.hu vagy ABCD1234"
              className="w-full bg-anthracite-900 border border-white/10 rounded-xl p-3 text-sm focus:border-electric outline-none"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wide text-slate-400 block mb-1">Összeg (kredit)</label>
            <input
              data-testid="gift-amount"
              type="number"
              min="1"
              max={balance}
              required
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="w-full bg-anthracite-900 border border-white/10 rounded-xl p-3 text-sm focus:border-electric outline-none"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wide text-slate-400 block mb-1">Üzenet (opcionális, max 280)</label>
            <textarea
              data-testid="gift-message"
              rows={2}
              maxLength={280}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Köszi a segítséget!"
              className="w-full bg-anthracite-900 border border-white/10 rounded-xl p-3 text-sm focus:border-electric outline-none resize-none"
            />
          </div>
          <button
            data-testid="gift-submit"
            type="submit"
            disabled={saving || !recipient || amount <= 0 || amount > balance}
            className="w-full inline-flex items-center justify-center gap-2 py-3 rounded-full bg-emerald-500 hover:bg-emerald-500/90 disabled:opacity-50 text-white text-sm font-medium transition-all"
          >
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
            {saving ? "Küldés…" : `Ajándékozás (-${amount} kredit)`}
          </button>
        </div>
      </form>
    </div>
  );
}
